import React, { Component } from 'react'
import insertBlock from 'draft-js-editor/lib/modifiers/insertBlock'

class BlockButton extends Component {

  render = () => {

    const {
      editorState,
      updateEditorState,
      blockType,
      children,
    } = this.props

    return <div
      style={{
        display: 'inline-block',
        verticalAlign: 'super',
        border: '1px solid #f0f0f0',
        borderRadius: 3,
        padding: 5,
        width: '100%',
        boxSizing: 'border-box',
        color: 'grey',
        //marginTop: 2,
        //marginBottom: 2,
        overflow: 'hidden',
      }}
      onMouseDown={(e) => {
        e.preventDefault()
        updateEditorState(insertBlock(editorState, blockType))
      }}
    >
      {children}
    </div>
  }
}

export default BlockButton


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/SideControl/BlockButton.js